<div>
  <app-skeleton-button-toggle-vehicle
    *ngFor="let item of [1, 2, 3, 4, 5, 6, 7]"
  ></app-skeleton-button-toggle-vehicle>
</div>
